export default function () {
  const counters = document.querySelectorAll('.js-number-countdown')

  counters.forEach((counter) => {
    // Remplace les virgules par des points pour la conversion en nombre
    const target = parseFloat(
      counter.getAttribute('data-target').replace(',', '.'),
    )
    let count = 0
    const increment = target / 200 // Ajustez cette valeur pour la vitesse de l'animation

    const updateCount = () => {
      count += increment

      if (count < target) {
        // Affiche les décimales si la cible en a, sinon affiche un entier
        counter.innerText =
          target % 1 !== 0
            ? count.toFixed(1).replace('.', ',')
            : Math.floor(count)
        setTimeout(updateCount, 10) // Ajustez cette valeur pour la fréquence de mise à jour
      } else {
        // Affiche la valeur cible finale correctement
        counter.innerText =
          target % 1 !== 0
            ? target.toFixed(1).replace('.', ',')
            : target.toString()
      }
    }

    // Initialise le texte à 0 après le chargement de la page
    counter.innerText = '0'
    updateCount()
  })
}
